export const Footer = () => {
    return (
        <footer className="footer">
            <div className="content has-text-centered">
                <p>by EKUK</p>
            </div>
        </footer>
    );
};
